import { Flex } from "@/components/layout/flexbox";

interface ReviewIconProps {
  size: number;
  backgroundColor: string;
  color?: string;
  style?: React.CSSProperties;
}

export function ReviewIcon({
  size,
  backgroundColor,
  color = "#FFF",
  ...props
}: ReviewIconProps) {
  const { style, ...moreProps } = props;
  return (
    <Flex
      width={size}
      height={size}
      style={{
        borderRadius: size,
        ...style,
      }}
      backgroundColor={backgroundColor}
      alignItems="center"
      justifyContent="center"
      {...moreProps}
    >
      <svg
        width={size * 0.5}
        height={size * 0.5}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4859 1.41602H7.05232C6.40376 1.41602 5.87312 1.94666 5.87312 2.59521V8.05268L8.23152 10.4111V3.77441H15.3067V9.67041H21.2027V22.6416H8.23152V18.3349L5.87312 15.9766V23.8208C5.87312 24.4694 6.40376 25 7.05232 25H22.3819C23.0305 25 23.5611 24.4694 23.5611 23.8208V8.49121L16.4859 1.41602ZM8.5772 17.013L10.8715 14.7188L4.66963 8.5169L2.37535 10.8112L8.5772 17.013ZM9.39601 17.8156L12.9712 19.1046L11.6741 15.5538L9.39601 17.8156ZM2.76449 6.61176C2.47263 6.3118 2.06728 6.13345 1.6214 6.13345C0.72963 6.13345 0 6.86308 0 7.75485C0 8.20073 0.178354 8.60608 0.470206 8.90604L1.80786 10.2437L4.10214 7.94941L2.76449 6.61176Z"
        />
      </svg>
    </Flex>
  );
}
